/**
 * 格式化日期
 * @param {date}   date  时间
 * @param {string} fmt   时间格式
 * return {string}
 */
export function formatDate(date: any, fmt: string) {
  if (!date || !fmt) {
    return date;
  }

  if (typeof date === 'string' && date.length === 8) {
    date = `${date.substr(0, 4)}-${date.substr(4, 2)}-${date.substr(6, 2)}`;
  }

  date = new Date(date.toString().replace(/-/g, '/'));

  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'H+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length));
  }

  Object.keys(o).forEach((k) => {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length),
      );
    }
  });

  return fmt;
}

/**
 * 格式化，value, max, min参数 今天 today, 明天 tomorrow, 昨天 yesterday
 * @param {string} date  时间
 * return {string}
 */
export function formatDays(date: any) {
  if (!date) {
    return '';
  }

  const format: string = 'yyyy-MM-dd';
  const keys = {
    today: 0,
    tomorrow: 1,
    yesterday: -1,
  };

  // 今天 today, 明天 tomorrow, 昨天 yesterday
  if (typeof keys[date] !== 'undefined') {
    const result = new Date();

    result.setDate(result.getDate() + keys[date]);

    return formatDate(result, format);
  }

  const reDate = /^(\d+[YMdhms])+$/;
  const reGroupDate = /(\d+)([YMdhms])/;

  // 年/月/日/小时/分/秒 1Y/1M/1d/1h/2m/1s
  if (reDate.test(date)) {
    const dates = date.match(new RegExp(reGroupDate, 'g'));
    const result = new Date();
    let value: any = null;
    let number = 0;

    if (dates && dates.length) {
      dates.forEach((key: string) => {
        value = key.match(reGroupDate);

        if (value && value.length > 2) {
          number = parseInt(value[1], 10);

          switch (value[2]) {
            // 年
            case 'Y':
              result.setFullYear(result.getFullYear() + number);
              break;
            // 月份
            case 'M':
              result.setMonth(result.getMonth() + number);
              break;
            // 日
            case 'd':
              result.setDate(result.getDate() + number);
              break;
            // 小时
            case 'h':
              result.setHours(result.getHours() + number);
              break;
            // 分
            case 'm':
              result.setMinutes(result.getMinutes() + number);
              break;
            // 秒
            case 's':
              result.setSeconds(result.getSeconds() + number);
              break;
            default:
              break;
          }
        }
      });
    }

    return formatDate(result, format);
  }

  return date;
}
